/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface StatesResponse {

        "states"?: Array<State>;
    }

}
